import { enumMembers, type ApiSchema } from "../apiSchema";
import { jsonBody, requestJson } from "../http/httpClient";
import { readObject, readOneOf } from "../http/jsonDecoding";
import { threadPath } from "./threadsApi";

/** The host's answer in the Thread to a tool version waiting on their PC (connector.md TA-6). */
export type ToolApprovalChoice = ApiSchema<"ToolApprovalChoice">;
/** What the PC's connector made of it; `no_answer` and `update_needed` come from the server. */
export type ToolApprovalOutcome = ApiSchema<"ToolApprovalAnsweredBody">["outcome"];
const TOOL_APPROVAL_OUTCOMES = enumMembers<ToolApprovalOutcome>({ recorded: true, not_pending: true, expired: true, not_owner: true, no_answer: true, update_needed: true });

/** Relays the host's answer to the PC holding the request; the connector there decides. */
export function answerToolApproval(threadId: string, turnId: string, requestId: string, answer: ToolApprovalChoice): Promise<ToolApprovalOutcome> {
  return requestJson({
    method: "POST",
    path: threadPath(threadId, `/turns/${encodeURIComponent(turnId)}/tool-approval`),
    body: jsonBody({ request_id: requestId, answer } satisfies ApiSchema<"ToolApprovalAnswerBody">),
    decodeResponse: (body) => readOneOf(readObject(body, "tool approval answer"), "outcome", TOOL_APPROVAL_OUTCOMES),
  });
}
